import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmIncidentManagementToolsRoute: InvariantJiraRoute = {
	name: 'products-jsm-incident-management-tools',
	path: '/jira/settings/products/jira-service-management-incident-management-tools',
	exact: true,
};
